<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">资产信息</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建资产</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        v-model="searchData.Keyword"
        clearable
        placeholder="请输入资产编号/名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column label="" width="50" type="selection">
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
        <el-table-column
          label="资产编号"
          align="center"
          prop="AssetCode"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="资产名称"
          align="center"
          prop="AssetName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="资产类型"
          align="center"
          prop="AssetTypeName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="资产分类"
          align="center"
          prop="AssetCategoryName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="资产规格型号"
          align="center"
          prop="AssetSpec"
          sortable
        >
        </el-table-column>

        <el-table-column label="数量" align="center" prop="Qty" sortable>
        </el-table-column>
        <!-- <el-table-column label="单价" align="center" prop="Price"> </el-table-column> -->
        <!-- <el-table-column label="金额" align="center" prop="Amount"> </el-table-column> -->
        <el-table-column
          label="使用状态"
          align="center"
          prop="StatusName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="折旧方法"
          align="center"
          prop="DepreciationsName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="折旧年限(年)"
          align="center"
          prop="DepreciationYear"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="残值率"
          align="center"
          prop="ResidualValueRate"
          sortable
        >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              fun(scope.row.ResidualValueRate)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="原值"
          align="center"
          prop="OriginalValue"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="管理部门"
          align="center"
          prop="ResponsibleDeptName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="使用部门"
          align="center"
          prop="UserDepartmentName"
          sortable
        >
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.OperationStatus === 0"
              @click="handleEdit(scope.row, false)"
              >编辑</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.OperationStatus === 1"
              @click="handleEdit(scope.row, true)"
              >查看</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.OperationStatus === 0"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import EditForm from './EditForm'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      searchData: {
        Condition: 'AssetName',
        Keyword: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm },
  methods: {
    handleSelect(selection) {
      this.selectedRows = selection
    },
    fun(val) {
      return val + '%'
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/AM/am_asset/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: {
            ...this.searchData,
            Type: this.AssetTreeSeacrh || '',
          },
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建资产信息')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该资产信息, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http.post('/AM/am_asset/DeleteData', ids).then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('删除成功')
              this.getDataList()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
        })
        .catch(() => {})
    },
    handleEdit(row, flag) {
      this.$refs.EditForm.openForm(
        flag ? '查看资产信息' : '编辑资产信息',
        row,
        flag
      )
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['AssetTreeSeacrh']),
  },
  watch: {
    AssetTreeSeacrh() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
